/** English display names for the language codes in the API registry (TranslationCatalog::LANGUAGES). */
export const LANGUAGE_NAMES_EN: Record<string, string> = {
  en: 'English', de: 'German', fr: 'French', es: 'Spanish', it: 'Italian', pt: 'Portuguese',
  nl: 'Dutch', pl: 'Polish', cs: 'Czech', sk: 'Slovak', hu: 'Hungarian', ro: 'Romanian',
  bg: 'Bulgarian', hr: 'Croatian', sl: 'Slovenian', tr: 'Turkish', ar: 'Arabic', zh: 'Chinese',
  ja: 'Japanese', ko: 'Korean', he: 'Hebrew', ru: 'Russian', sv: 'Swedish', no: 'Norwegian',
  fi: 'Finnish', bs: 'Bosnian', el: 'Greek', et: 'Estonian', hi: 'Hindi', 'zh-TW': 'Chinese (Traditional)',
  'en-AU': 'English (Australia)', 'en-CA': 'English (Canada)',
  'es-GT': 'Spanish (Guatemala)', 'es-CO': 'Spanish (Colombia)', 'es-CR': 'Spanish (Costa Rica)',
  'es-EC': 'Spanish (Ecuador)', 'es-MX': 'Spanish (Mexico)',
};

/** Regional variants and the language they are based on (TranslationCatalog::REGIONAL_BASE). */
export const REGIONAL_BASE: Record<string, string> = {
  'en-AU': 'en', 'en-CA': 'en',
  'es-GT': 'es', 'es-CO': 'es', 'es-CR': 'es', 'es-EC': 'es', 'es-MX': 'es',
};

/** Native names and flag country codes for the regional variants, used by the language pickers. */
export const REGIONAL_LANGUAGES: { code: string; label: string; flag: string }[] = [
  { code: 'en-AU', label: 'English (Australia)', flag: 'au' },
  { code: 'en-CA', label: 'English (Canada)', flag: 'ca' },
  { code: 'es-CO', label: 'Español (Colombia)', flag: 'co' },
  { code: 'es-CR', label: 'Español (Costa Rica)', flag: 'cr' },
  { code: 'es-EC', label: 'Español (Ecuador)', flag: 'ec' },
  { code: 'es-GT', label: 'Español (Guatemala)', flag: 'gt' },
  { code: 'es-MX', label: 'Español (México)', flag: 'mx' },
];

export function baseLanguage(code: string): string {
  return REGIONAL_BASE[code] ?? code;
}
